import { render, staticRenderFns } from "./ChampionsHome.vue?vue&type=template&id=677c7f0b&scoped=true"
import script from "./ChampionsHome.vue?vue&type=script&setup=true&lang=js"
export * from "./ChampionsHome.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677c7f0b",
  null
  
)

export default component.exports